import personApiServices from '../../api/person';
import cookies from '../../utils/cookies';

function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export default {
  getMe: async ({ state, commit }, { email = '', force = true }) => {
    let personEmail = email
    if (personEmail) {
      const token = cookies.getItem('token');

      const JWT = parseJwt(token);
      personEmail = JWT.email
    }

    const key = personEmail;
    const cachedPersonEmail = state.cachedPerson[key];

    if (!force && cachedPersonEmail) {
      commit('SET_PERSON', cachedPersonEmail);
      return cachedPersonEmail;
    }

    const { data } = await personApiServices.getMe();
    if (!data) return [];
    const { person } = data;
    commit('SET_PERSON', person);
    commit('CACHE_PERSON', { key, person });

    return person;
  },
  getMeByEmail: async ({ state, commit }, { email, force = true }) => {
    const key = `person${email}`;
    const cachedPersonEmail = state.personByEmail[key];

    if (!force && cachedPersonEmail) {
      commit('SET_PERSON_BY_EMAIL', cachedPersonEmail);
      return cachedPersonEmail;
    }

    const { data } = await personApiServices.getByEmail(email);
    if (!data) return [];
    commit('SET_PERSON_BY_EMAIL', data);
    commit('CACHE_PERSON_BY_EMAIL', { key, data });

    return data;
  },
  getPersons: async ({ state, commit }, { includeJobs = false, force = true }) => {
    const key = `persons&includeJobs=${includeJobs}`;
    const cachedPersons = state.cachedPersons[key];
    if (!force && cachedPersons) {
      commit('SET_PERSONS', cachedPersons);
      return cachedPersons;
    }

    const { data } = await personApiServices.getAll({ includeJobs });
    if (!data) return [];
    const { persons } = data;

    commit('SET_PERSONS', persons);
    commit('CACHE_PERSONS', { key, persons });

    return data;
  },
  setRating: async ({ state, commit }) => {
    const { rating } = state.person;
    commit('SET_RATING', rating);
  },
};
